import {ID} from '../../_metronic/helpers'
import {FilterFieldProps} from './Filter'
import {ListGrouping} from './ListGrouping'
import {SearchComponent} from './Search'
import {Toolbar} from './Toolbar'

type Props = {
  updateState: (state: any) => void
  isLoading: boolean
  selected?: any[]
  clearSelected?: () => void
  deleteAction?: (ids: ID) => Promise<void>
  fields?: (FilterFieldProps | string)[]
  title: string
  refetch?: () => void
  filterMode?: 'apply' | 'instant'
  searchFilters?: FilterFieldProps[]
  searchAble?: boolean
  searchFields?: string[]
  extras?: {
    title: string
    onClick?: () => void
    isLoading?: boolean
    icon?: string
  }[]
  createAble?: boolean
  customCreatePath?: string
}

export const Header = (props: Props) => {
  return (
    <div className='flex flex-col md:flex-row md:items-center justify-between px-6 pt-6 pb-0 border-b border-gray-200 bg-white'>
      <SearchComponent
        updateState={props.updateState}
        searchFilters={props.searchFilters}
        title={props.title}
        searchAble={props.searchAble}
        searchFields={props.searchFields}
      />
      {/* begin::Card toolbar */}
      <div className='flex justify-end mt-4 md:mt-0'>
        {/* begin::Group actions */}
        {props.selected &&
        props.clearSelected &&
        props.deleteAction &&
        props.selected.length > 0 ? (
          <ListGrouping
            selected={props.selected}
            clearSelected={props.clearSelected}
            action={props.deleteAction}
            refetch={props.refetch}
          />
        ) : (
          <Toolbar
            title={props.title}
            isLoading={props.isLoading}
            updateState={props.updateState}
            fields={props.fields}
            filterMode={props.filterMode}
            extras={props.extras}
            createAble={props.createAble}
            customCreatePath={props.customCreatePath}
          />
        )}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}
